import {
  ReviewActivityQuery,
  ReviewActivityQueryVariables,
} from "@outschool/gql-frontend-generated";
import { gql, useQueryWithPreviousData } from "@outschool/ui-apollo";

const reviewActivityQuery = gql`
  query ReviewActivity($sectionUid: ID!) {
    activityBySectionUidIfLatestMeetingNotReviewed(sectionUid: $sectionUid) {
      uid
      titleTranslated
      leader {
        name
        photo
      }
      details {
        photo
      }
    }
  }
`;

export default function useReviewActivity(sectionUid: string | null) {
  const { data, loading, error } = useQueryWithPreviousData<
    ReviewActivityQuery,
    ReviewActivityQueryVariables
  >(reviewActivityQuery, {
    variables: { sectionUid: sectionUid ?? "" },
    skip: !sectionUid,
  });
  return {
    activity: data?.activityBySectionUidIfLatestMeetingNotReviewed,
    loading,
    error,
  };
}
